import React, { useEffect, useState } from 'react'
import './features-content.scss'
import { recordingEntitties } from '../../constant';
import OptionLayout from '../OptionLayout';
import { useTranslation } from 'react-i18next';
import sessionPage from '../../assets/images/session-page.png';
import Table from '../Table';

const FeaturesContent = () => {
	const [entities, setEntities] = useState(recordingEntitties);
	const [selectedEntities, setSelectedEntities] = useState([]);
	const { t } = useTranslation();

	const allEntities = recordingEntitties.flatMap(entity => entity.entities);
	console.log('entities', entities);

	const columns = [
		{
			heading: `${t('name')}`,
			accessor: 'name',
			Cell: ({ row }) => <div>
				<span>{t(row.name)}</span>
			</div>
		},
		{
			heading: `${t('counter_dependency')}`,
			accessor: 'counter_dependency',
			Cell: ({ row }) => <div>
				<span>{row.counter_dependency?.length > 0 ? row.counter_dependency.map(item => t(item)).join(', ') : '-'}</span>
			</div>
		},
		{
			heading: `${t('dependency')}`,
			accessor: 'dependency',
			Cell: ({ row }) => <div>
				<span>{row.dependency?.length > 0 ? row.dependency.map(item => t(item)).join(', ') : '-'}</span>
			</div>
		},
		{
			heading: `${t('description')}`,
			accessor: 'description',
			Cell: ({ row }) => <div>
				<span>{t(row.description)}</span>
			</div>
		}
	]


	const handleSelection = (defaultSelected, selectedValue) => {

		let settings = [...entities];

		settings.forEach((s) => {
			s?.entities?.forEach((record) => {
				if (defaultSelected && defaultSelected.includes(record.id)) {
					record.isSelected = selectedValue;
				}

				if (record.counter_dependency && record.counter_dependency.length > 0) {
					record.counter_dependency.forEach((counterDepId) => {
						const counterDependentRecord = settings
							.flatMap((s) => s?.entities || [])
							.find((r) => r.id === counterDepId);

						if (counterDependentRecord) {
							if (!defaultSelected.includes(counterDependentRecord.id)) {
								counterDependentRecord.isSelected = false;
							}
						}
					});
				}
			});
		});

		setEntities(settings);

		setSelectedEntities(getSelectedEntries(settings));
	};

	const getSelectedEntries = (settings) => {
		let selectedEntries = [];

		settings?.forEach((s) => {
			s?.entities?.forEach((record) => {
				if (record.isSelected) {
					selectedEntries.push(record);
				}
			});
		});

		return selectedEntries;
	};

	return (
		<div className='features-containers'>
			<h1>{t('features')}</h1>
			<p>{t('mereos_policy_desc')}</p>

			<h1>{t('mereos_test_configuration_advance_guide')}</h1>
			<p>{t('mereos_empowers_test_administrators')}</p>

			<h1>{t('customizable_proctoring_features')}</h1>
			<p>{t('mereos_settings_enable_administrators')}</p>
			<ul className='numeric-bullets'>
				<li><span>{t('recording_options')}</span> {t('capture_audio_video')}</li>
				<li><span>{t('lockdown_options')}</span> {t('restrict_or_detect')}</li>
				<li><span>{t('verification_options')}</span> {t('confirm_the_test_takers')}</li>
				<li><span>{t('ai_features')}: </span> {t('artificial_intelligence_overview_desc')}</li>
			</ul>
			<p>{t('the_system_modular_design_allows')}</p>

			<h1>{t('enhanced_security_for_high_stakes_exams')}</h1>
			<p>{t('for_assessments_requiring')}<br />{t('test_administrators_can')}:</p>
			<ul>
				<li>{t('activate_all_available_features')}</li>
				<li>{t('ensure_rigorous_monitoring')}</li>
				<li>{t('configure_customizable_thresholds')}</li>
			</ul>

			<h1>{t('streamlined_decision_making')}</h1>
			<p>{t('test_administrators_retain_ultimate')}</p>
			<ul>
				<li>{t('selecting_appropriate_security')}</li>
			</ul>
			<p>{t('mereos_proctors_retain_ultimate_responsibility')}</p>
			<ul>
				<li>{t('monitoring_in_real_time_or_reviewing')}</li>
			</ul>
			<p>{t('mereos_intuitive_design_and_actionable')}</p>

			<h1>{t('mereos_admin_panel_overview')}</h1>
			<p>{t('mereos_admin_panel_overview_desc')}</p>

			<h1>{t('suspicion_indicators')}</h1>
			<p>{t('suspicion_indicators_desc')}</p>
			<ul>
				<li>{t('high_suspicion_scores')}</li>
				<li>{t('low_suspicion_scores')} </li>
			</ul>
			<p>{t('low_suspicion_scores_desc')}</p>

			<h1>{t('detailed_exam_review')}</h1>
			<p>{t('proctors_can_click_on_a_test')} </p>
			<p>{t('key_features_include')}</p>
			<ul>
				<li><span>{t('video_log')}:</span> {t('video_log_desc')}</li>
				<li><span>{t('annotations')}:</span> {t('annotations_desc')} </li>
				<li><span>{t('proctor_review')}</span>{t('proctor_review_desc')}</li>
			</ul>
			<div className='session-image'>
				<img src={sessionPage} />
			</div>
			<h1>{t('live_monitoring_option')}</h1>
			<p>{t('live_monitoring_option_desc')}</p>

			<h1>{t('entity_relations')}</h1>
			<p>
				{t('entity_relations_desc')}
			</p>
			<div>
				<Table
					column={columns}
					data={allEntities}
					showPagination={false}
					onSortedList={() => null}
				/>
			</div>
		</div>
	)
}

export default FeaturesContent